import { getBoclipsSearch } from "features/News/services/boclips.service";
import { getFilterDateValueKeys } from "utils/date-filter.util";
import { searchConfig } from "config";

const createBoclipsAdapter = ({ searchContext }) => {
  const { currentSearchTerm, currentTimeframe, startDate, endDate } = searchContext;

  const enabled = Boolean(currentSearchTerm);
  const dependencies = [currentSearchTerm, currentTimeframe, startDate, endDate];

  const fetchPage = async (page) => {
    if (!enabled) return { items: [], nextCursor: page, hasMore: false };
    const filteredDateValue = getFilterDateValueKeys(currentTimeframe, startDate, endDate);
    const data = await getBoclipsSearch(currentSearchTerm, filteredDateValue, page);
    const items = data?.embedded?.videos || [];
    const total = data?.page?.totalElements || 0;
    const hasMore = page * searchConfig.boclips.count < total;
    return { items, nextCursor: page + 1, hasMore };
  };

  return {
    idKey: "id",
    initialCursor: 1, // boclips is page-based
    fetchPage,
    dependencies,
    enabled,
    isPageMode: true,
  };
};

export default createBoclipsAdapter;


